<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <div class="seat-container">
      <div class="header">
        <FCTitle :h2="h2" :h3="h3" />
        <a @click="$router.go(-1)">
          <img :src="require(`@/assets/icons/close.svg`)" alt />
        </a>
      </div>
      <div class="seat-finder">
        <iframe src="https://3ddigitalvenue.com/3dmap/clients/fc-cincinnati/bowl/"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import FCTitle from "@/components/patterns/FCTitle";
export default {
  components: {
    FCTitle,
  },
  mounted() {
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.virtualTour.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.virtualTour.nav;
  },
  data() {
    return {
      h2: "Virtual Tour",
      h3: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-cometogether.jpg");
  background-size: cover;
  background-position: center;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 20px;
}
.seat-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  background: #fff;
  z-index: 2;
}
.seat-finder {
  width: calc(100% - 40px);
  height: calc(100% - 85px);
  position: relative;
  margin-top: 0px;
  margin-left: 20px;
  background: #ccc;
  overflow: hidden;
}
iframe {
  width: 100%;
  height: 100%;
}
</style>